import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'bizbrain-warning-dialog',
    templateUrl: 'bizbrain-warning-dialog.html',
    styleUrls: ['./bizbrain.component.scss'],
})
export class BizbrainWarningDialog implements OnInit {
    optionName: string = 'Upload file';
    constructor(public dialogRef: MatDialogRef<BizbrainWarningDialog>, @Inject(MAT_DIALOG_DATA) public data) {}
    ngOnInit(): void {
        if (this.data === 'file') {
            this.optionName = 'Upload file';
        } else {
            this.optionName = 'paste data as text';
        }
    }

    close(): void {
        this.dialogRef.close();
    }
}
